<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import moment from "moment";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { Helper } from "@/mixin/helper";

import { required, requiredIf, email, numeric } from "vuelidate/lib/validators";

import {
	CREATE_EMPLOYEE,
	GET_DETAIL_EMPLOYEE,
	UPDATE_EMPLOYEE,
} from "@/services/api/master/employees";
import { GET_DEPARTMENT } from "@/services/api/setting/employee/department";
import { GET_RECRUITMENT } from "@/services/api/setting/employee/recruitment";
import { setTimeout } from "optimism";

moment.locale("id");
/**
 * Starter component
 */
export default {
	page: {
		title: "Form Karyawan",
		meta: [{ name: "description", content: appConfig.description }],
	},
	components: {
		Layout,
		PageHeader,
		Multiselect,
	},
	mixins: [Helper],
	apollo: {
		employeeRecruitedAts: {
			query: GET_RECRUITMENT,
		},
		companyStructures: {
			query: GET_DEPARTMENT,
		},
		employee: {
			query: GET_DETAIL_EMPLOYEE,
			fetchPolicy: 'no-cache',
			variables() {
				return {
					filter: {
						userId: parseInt(this.id),
					},
				};
			},
			// Disable the query
			skip() {
				return this.$route.params.id === undefined;
			},
			result({ data, loading }) {
				if (!loading) {
					this.initEditPage(data.employee.employee);
				}
			},
		},
	},
	data() {
		return {
			id: this.$route.params.id || 0,
			selected: {
				userDocs: [],
				userWorkHistory: [],
			},
			selectedModel: {
				userDocs: [],
				userWorkHistory: [],
			},
			allSelected: {
				userDocs: false,
				userWorkHistory: false,
			},
			indeterminate: {
				userDocs: true,
				userWorkHistory: true,
			},
			employeeRecruitedAts: {
				employeeRecruitedAts: [],
			},
			companyStructures: {
				companyStructures: [],
			},
			employee: {
				employee: {},
			},

			defaultdate: "",
			tData: {
				dataIdentity: [
					{
						id: "1",
						columnDocument: "Kang Tri",
						columnNomor: "7676657567567",
						columnExpired: "30 Apr 2022",
						columnStatus: 0,
					},
					{
						id: "2",
						columnDocument: "Kang Hadi",
						columnNomor: "9389024232432",
						columnExpired: "3 Mei 2022",
						columnStatus: 1,
					},
					{
						id: "3",
						columnDocument: "Kang Octa",
						columnNomor: "1212314242442",
						columnExpired: "19 Jun 2022",
						columnStatus: 2,
					},
				],
				dataExperience: [
					{
						id: "1",
						columnCompany: "Sinarmas Land Plaza",
						columnPosition: "Driver",
						columnEntryDate: "30 Apr 2022",
						columnExitDate: "30 Jun 2022",
					},
					{
						id: "2",
						columnCompany: "Delta Plaza",
						columnPosition: "Staff - Operational",
						columnEntryDate: "1 Apr 2022",
						columnExitDate: "1 Jun 2022",
					},
				],
			},
			currentDate: new Date(),

			form: {
				employeeIdentifier: null,
				phoneNo: null,
				gender: "M",
				email: null,
				birthplace: null,
				birthdate: null,
				maritalStatus: null,
				address: null,
				department: null,
				unit: null,
				joinOn: null,
				recruitedAt: null,
				isEmployee: true,
				isActive: true,
				inactiveOn: null,
				inactiveCause: null,
				isDriver: false,
				positionId: null,
				userDocs: [],
				userWorkHistory: [],
				photo: "",
				photoExt: "",
				position: null
			},
			imagePreview: require(`@/assets/images/default-image-user.png`),
			maritalStatuses: [
				{ key: "M", label: "Kawin" },
				{ key: "S", label: "Belum Kawin" },
				{ key: "D", label: "Cerai Hidup" },
				{ key: "X", label: "Cerai Mati" },
			],
			loading: false,
			isFileError: false,
			isActiveOpen: false,
			docTypeOptions: [
				'KTP',
				'KITAS',
				'NPWP',
				'PASPOR',
				'SIM A',
				'SIM B1',
				'SIM B2',
				'SIM C',
				'SIM Internasional',
				'BPJS Kesehatan',
				'BPJS Ketenagakerjaan',
			]
		};
	},
	validations: {
		form: {
			email: { required, email },
			fullname: { required },
			gender: { required },
			employeeIdentifier: { required },
			position: { required },
			inactiveOn: {
				required: requiredIf(function () {
					return this.form.isActive === false;
				}),
			},
			inactiveCause: {
				required: requiredIf(function () {
					return this.form.isActive === false;
				}),
			},
			phoneNo: {
				numeric
			},
			userDocs: {
				$each: {
					docType: {
						required: requiredIf(function () {
							return (
								this.form.userDocs !== undefined &&
								this.form.userDocs.length > 0
							);
						}),
					}
				},
			},
			userWorkHistory: {
				$each: {
					companyName: {
						required: requiredIf(function () {
							return (
								this.form.userWorkHistory !== undefined &&
								this.form.userWorkHistory.length > 0
							);
						}),
					},
					position: {
						required: requiredIf(function () {
							return (
								this.form.userWorkHistory !== undefined &&
								this.form.userWorkHistory.length > 0
							);
						}),
					},
					joinedOn: {
						required: requiredIf(function () {
							return (
								this.form.userWorkHistory !== undefined &&
								this.form.userWorkHistory.length > 0
							);
						}),
					},
					leftOn: {
						required: requiredIf(function () {
							return (
								this.form.userWorkHistory !== undefined &&
								this.form.userWorkHistory.length > 0
							);
						}),
					},
				},
			},
		},
	},
	computed: {
		dataIdentity() {
			return [
				{
					key: "check",
					thClass: "mc-table--30",
					sortable: false,
				},
				{
					key: "columnDocument",
					label: "Nama Dokumen",
					thClass: "mc-table--50",
					sortable: true,
				},
				{
					key: "columnNomor",
					label: "Nomor Dokumen",
					thClass: "mc-table--50",
					sortable: true,
				},
				{
					key: "columnExpired",
					label: "Tanggal Akhir Berlaku",
					thClass: "mc-table--50",
					sortable: true,
				},
				{
					key: "columnStatus",
					label: this.$t("master.form.fleet.documentPermit.status.text"),
					thClass: "mc-table--50",
					sortable: true,
				},
			];
		},
		dataExperience() {
			return [
				{
					key: "check",
					thClass: "mc-table--30",
					sortable: false,
				},
				{
					key: "columnCompany",
					label: "Nama Perusahaan",
					thClass: "mc-table--50",
					sortable: true,
				},
				{
					key: "columnPosition",
					label: "Posisi",
					thClass: "mc-table--50",
					sortable: true,
				},
				{
					key: "columnEntryDate",
					label: "Tanggal Masuk",

					sortable: true,
				},
				{
					key: "columnExitDate",
					label: "Tanggal Keluar",
					thClass: "mc-table--50",
					sortable: true,
				},
			];
		},
		title() {
			// return `${this.$t("menuitems.masterData.text")} ${this.$t(
			//   "menuitems.masterData.list.fleet"
			// )}`;
			return this.$route.params.id === undefined
				? this.$t('master.form.driver.action.add')
				: this.$t('master.form.driver.action.update');
		},
		items() {
			return [
				{
					text: this.$t("menuitems.masterData.text"),
				},
				{
					text: this.$t('menuitems.masterData.list.employee'),
				},
				{
					// text: "Form",
					// active: true,
					text:
						this.$route.params.id === undefined
							? this.$t('master.form.driver.action.add')
							: this.employee.employee.fullname,
				},
			];
		},
		department() {
			return this.companyStructures.companyStructures.filter(function (item) {
				return item.parentId == null && !item.isPosition;
			});
		},
		unit() {
			return this.companyStructures.companyStructures.filter(function (item) {
				return item.parentId != null && !item.isPosition;
			});
		},
		position() {
			let allPosition = this.companyStructures.companyStructures.filter(function (item) {
				return item.isPosition;	
			})
			let pos = []
			let oldPosition = this.oldData.position
			
			for (let i=0; i<allPosition.length; i++){
				let item = allPosition[i]
				if(oldPosition === null || oldPosition === undefined){
					pos.push(item)
					continue
				}
				if(oldPosition.name !== 'Driver' && item.name !== 'Driver'){
					pos.push(item)
				}
				else if(oldPosition.name === 'Driver' && item.name === 'Driver'){
					pos.push(item)
				}
			}
			return pos
		},
		oldData() {
			if (this.employee.employee !== undefined) {
				var old = this.employee.employee;
				var history = old.userWorkHistory || [];
				var resHistory = [];
				history.forEach(function (item) {
					resHistory.push({
						...item,
						leftOn: moment(item.leftOn).format("YYYY-MM-DD"),
						joinedOn: moment(item.joinedOn).format("YYYY-MM-DD"),
						type: "data",
					});
				});
				old.userWorkHistory = resHistory;

				var docs = old.userDocs || [];
				var resDocs = [];
				docs.forEach(function (item) {
					resDocs.push({
						...item,
						validUntil: moment(item.validUntil).format("YYYY-MM-DD"),
						type: "data",
					});
				});
				old.userDocs = resDocs;

				var formMarital = old.maritalStatus;
				var marital = this.maritalStatuses.find(function (item) {
					return item.key == formMarital;
				});
				old.maritalStatus = marital || null;

				var recruitedAt = old.recruitedAt;
				var recruit = this.employeeRecruitedAts.employeeRecruitedAts.find(
					function (item) {
						return item.text == recruitedAt;
					}
				);
				old.recruitedAt = recruit || null;

				return old;
			}

			return null;
		},
		docTypeUnSelected() {
			var selectedDoc = this.form.userDocs.map((item) => item.docType);
			selectedDoc = selectedDoc.filter((item) => item != null);

			var options = this.docTypeOptions.filter((item) => {
				return !selectedDoc.includes(item);
			});

			return options;
		},
		yearShow() {
			var year = this.form.birthdate;
			if (year !== null) {
				var now = moment();
				var pick = moment(year).format("YYYY-MM-DD");
				var diff = moment(now).diff(pick, "years");

				return year + ` (${diff})`;
			}
			return null;
		},
	},
	created() {
		for (let i = 0; i < this.form.userDocs.length; i++) {
			this.selectedModel.userDocs.push(false);
		}

		this.$watch("selected.userDocs", (newValue) => {
			if (newValue.length === 0) {
				this.indeterminate.userDocs = false;
				this.allSelected.userDocs = false;
			} else if (newValue.length == this.form.userDocs.length) {
				this.indeterminate.userDocs = false;
				this.allSelected.userDocs = true;
			} else {
				this.indeterminate.userDocs = true;
				this.allSelected.userDocs = false;
			}
		});
	},
	methods: {
		initEditPage(data) {
			this.employee.employee = data;
			this.form.employeeIdentifier = data.employeeIdentifier;
			this.form.fullname = data.fullname;
			this.form.phoneNo = data.phoneNo;
			this.form.gender = data.gender;
			this.form.email = data.email;
			this.form.birthplace = data.birthplace;
			this.form.birthdate = data.birthdate;
			this.form.address = data.address;
			this.form.isEmployee = data.isEmployee;
			this.form.isActive = data.isActive;
			this.form.isDriver = data.isDriver;
			this.form.position = data.position;
			this.form.inactiveOn = data.inactiveOn;
			this.form.inactiveCause = data.inactiveCause;
			this.changeStatus(data.isActive);

			if (data.photograph != null && data.photograph != "") {
				this.imagePreview = data.photograph;
			}

			var formMarital = data.maritalStatus;
			var marital = this.maritalStatuses.find(function (item) {
				if(typeof formMarital === 'object'){
					return item.key == formMarital.key;
				}
				return item.key == formMarital;
			});
			this.form.maritalStatus = marital || null;
			this.form.positionId = data.position ? data.position.structureId : null;

			if (this.form.position != null) {
				setTimeout(() => {
					this.positionChanged();
				}, 500);
			}

			var recruitedAt = data.recruitedAt;
			var recruit = this.employeeRecruitedAts.employeeRecruitedAts.find(
				function (item) {
					return item.text == recruitedAt;
				}
			);
			this.form.recruitedAt = recruit || null;
			this.form.joinOn = data.joinOn;

			var history = data.userWorkHistory || [];
			var resHistory = [];
			history.forEach(function (item) {
				resHistory.push({
					...item,
					leftOn: moment(item.leftOn).format("YYYY-MM-DD"),
					joinedOn: moment(item.joinedOn).format("YYYY-MM-DD"),
					disabledLeftDate: function (date) {
						var joinedOn = new Date(item.joinedOn);
						return date < joinedOn.setDate(joinedOn.getDate() - 1);
					},
					type: "data",
				});
			});
			this.form.userWorkHistory = resHistory;

			var docs = data.userDocs || [];
			var resDocs = [];
			docs.forEach(function (item) {
				resDocs.push({
					...item,
					validUntil: item.validUntil ? moment(item.validUntil).format("YYYY-MM-DD") : null,
					type: "data",
				});
			});
			this.form.userDocs = resDocs;
		},
		submitForm() {
			// stop here if form is invalid
			this.$v.$touch();
		},
		toggleAll(checked, param) {
			this.selectedModel[param] = [];
			this.selected[param] = [];
			if (checked) {
				for (let i = 0; i < this.form[param].length; i++) {
					this.selected[param].push(i);
					this.selectedModel[param].push(true);
				}
			} else {
				for (let i = 0; i < this.form[param].length; i++) {
					this.selectedModel[param].push(false);
				}
				this.selected[param] = [];
			}
		},
		checkTable(event, data, param) {
			if (event) {
				this.selected[param].push(data.index);
			} else {
				var myIndex = this.selected[param].indexOf(data.index);
				if (myIndex !== -1) {
					this.selected[param].splice(myIndex, 1);
				}
			}
		},
		add(param, obj) {
			this.form[param].push(obj);
		},
		checkStatus(index) {
			const today = new Date();
			const zeroPad = (num, places) => String(num).padStart(places, "0");
			const date =
				today.getFullYear() +
				"-" +
				zeroPad(today.getMonth() + 1, 2) +
				"-" +
				today.getDate();
			if (date >= this.form[index].expired) {
				this.form[index].status = "expired";
			} else {
				var range = this.getDatesInRange(date, this.form[index].expired).length;
				if (range <= 30) {
					this.form[index].status = "near";
				} else {
					this.form[index].status = "active";
				}
			}
		},
		getDatesInRange(startDate, endDate) {
			startDate = new Date(startDate);
			endDate = new Date(endDate);
			const date = new Date(startDate.getTime());

			const dates = [];

			while (date <= endDate) {
				dates.push(new Date(date));
				date.setDate(date.getDate() + 1);
			}

			return dates;
		},
		toDelete(param) {
			this.selected[param].sort();
			this.selected[param].reverse();
			this.selected[param].forEach((row) => {
				this.$delete(this.form[param], row);
			});
			this.selected[param] = [];
			this.selectedModel[param] = [];

			this.indeterminate[param] = false;
			this.allSelected[param] = false;
			for (let i = 0; i < this.form[param].length; i++) {
				this.selectedModel[param].push(false);
			}
		},
		checkEmpty() {
			var isEmpty = true;
			var forms = this.form;
			var excepts = ["status", "gender", "isEmployee", "isActive"];
			Object.keys(this.form).forEach(function (key) {
				if (forms[key] != null && forms[key] != "") {
					if (typeof forms[key] !== "object") {
						if (!excepts.includes(key)) {
							isEmpty = false;
						}
					} else {
						if (!excepts.includes(key)) {
							if (Array.isArray(forms[key])) {
								if (forms[key].length > 0) {
									isEmpty = false;
								}
							} else {
								Object.keys(forms[key]).forEach(function (subKey) {
									if (forms[key][subKey] != null && forms[key][subKey] != "") {
										isEmpty = false;
									}
								});
							}
						}
					}
				}
			});

			return isEmpty;
		},
		checkChanged() {
			var isChanged = false;
			var forms = this.form;
			var formOld = this.oldData;
			var excepts = ["department", "unit", "photoExt", "positionId", "photo"];
			Object.keys(this.form).forEach(function (key) {
				if (!excepts.includes(key)) {
					if (forms[key] != formOld[key]) {
						if (key == "userDocs" || key == "userWorkHistory") {
							if (JSON.stringify(forms[key]) != JSON.stringify(formOld[key])) {
								isChanged = true;
							}
						} else {
							isChanged = true;
						}
					}
				}
			});

			return isChanged;
		},
		toCancel() {
			var isEmpty = this.checkEmpty();
			if (this.$route.params.id) {
				isEmpty = !this.checkChanged();
			}

			if (isEmpty) {
				this.$router.push("/master/employee");
			} else {
				Swal.fire({
					title: "Batalkan",
					text: "Anda yakin akan membatalkan",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#f46a6a",
					cancelButtonColor: "#34c38f",
					confirmButtonText: "Ya",
					cancelButtonText: "Tidak",
				}).then((result) => {
					if (result.value) {
						this.$router.push("/master/employee");
					}
				});
			}
		},

		positionChanged() {
			var positionId = this.form.position.parentId || this.form.position.unitId;

			this.form.unit = this.unit.find(function (item) {
				return item.structureId == positionId;
			});

			if (this.form.unit) {
				var unitId = this.form.unit.parentId;
				this.form.department = this.department.find(function (item) {
					return item.structureId == unitId;
				});
			} else {
				this.form.unit = null;
				this.form.department = null;
			}
		},

		validate() {
			// Checking validation
			this.$v.$touch();
			if (this.$v.form.$error) {
				return false;
			}
			return true;
		},

		toSave() {
			var validate = this.validate();
			if (!validate) {
				return;
			}

			var userObject = {};
			if (this.$route.params.id !== undefined) {
				userObject = { userId: parseInt(this.id) };
			}

			var userDocs = [];
			this.form.userDocs.forEach(function (item) {
				userDocs.push({
					docType: item.docType,
					docNumber: item.docNumber || null,
					validUntil: item.validUntil || null,
					...userObject,
				});
			});

			var userWorkHistory = [];
			this.form.userWorkHistory.forEach(function (item) {
				userWorkHistory.push({
					companyName: item.companyName,
					position: item.position,
					joinedOn: item.joinedOn,
					leftOn: item.leftOn,
					...userObject,
				});
			});

			var uDocsObject = {};
			if (userDocs.length > 0) {
				uDocsObject = { userDocs: userDocs };
			} else {
				uDocsObject = { userDocs: [] };
			}

			var uHistoryObject = {};
			if (userWorkHistory.length > 0) {
				uHistoryObject = { userWorkHistory: userWorkHistory };
			} else {
				uHistoryObject = { userWorkHistory: [] };
			}

			var photoObject = {};
			if (this.form.photo != "" && this.form.photo != null) {
				photoObject = {
					photo: this.form.photo,
					photoExt: this.form.photoExt,
				};
			}

			var isDriver = {};
			if (this.form.position) {
				if (
					this.form.position.name.toLowerCase() == "pengemudi" ||
					this.form.position.name.toLowerCase() == "driver"
				) {
					isDriver = {
						isDriver: true,
					};
				} else {
					isDriver = {
						isDriver: false,
					};
				}
			}

			var input = {
				birthdate: this.form.birthdate,
				birthplace: this.form.birthplace,
				fullname: this.form.fullname,
				gender: this.form.gender,
				maritalStatus: this.form.maritalStatus
					? this.form.maritalStatus.key
					: null,
				address: this.form.address,
				email: this.form.email,
				employeeIdentifier: this.form.employeeIdentifier,
				phoneNo: this.form.phoneNo,
				isEmployee: this.form.isEmployee,
				recruitedAt: this.form.recruitedAt ? this.form.recruitedAt.text : null,
				joinOn: this.form.joinOn,
				isActive: this.form.isActive,
				inactiveOn: this.form.inactiveOn,
				inactiveCause: this.form.inactiveCause,
				positionId: this.form.position ? this.form.position.structureId : null,
				...uDocsObject,
				...uHistoryObject,
				...photoObject,
				...isDriver,
			};

			if (this.$route.params.id !== undefined) {
				var oldDocs = [];
				if (this.oldData.userDocs !== undefined) {
					this.oldData.userDocs.forEach(function (item) {
						oldDocs.push({
							docType: item.docType,
							docNumber: item.docNumber,
							validUntil: item.validUntil,
							...userObject,
						});
					});
				}

				var oldHistory = [];
				if (this.oldData.userWorkHistory !== undefined) {
					this.oldData.userWorkHistory.forEach(function (item) {
						oldHistory.push({
							companyName: item.companyName,
							position: item.position,
							joinedOn: item.joinedOn,
							leftOn: item.leftOn,
							...userObject,
						});
					});
				}

				var uOldDocs = {};
				if (oldDocs.length > 0) {
					uOldDocs = { userDocs: oldDocs };
				} else {
					uOldDocs = { userDocs: [] };
				}

				var uOldHistory = {};
				if (oldHistory.length > 0) {
					uOldHistory = { userWorkHistory: oldHistory };
				} else {
					uOldHistory = { userWorkHistory: [] };
				}

				var oldData = {
					birthdate: this.oldData.birthdate,
					birthplace: this.oldData.birthplace,
					fullname: this.oldData.fullname,
					gender: this.oldData.gender,
					maritalStatus: this.oldData.maritalStatus
						? this.oldData.maritalStatus.key
						: null,
					address: this.oldData.address,
					email: this.oldData.email,
					employeeIdentifier: this.oldData.employeeIdentifier,
					phoneNo: this.oldData.phoneNo,
					isEmployee: this.oldData.isEmployee,
					recruitedAt: this.oldData.recruitedAt
						? this.oldData.recruitedAt.text
						: null,
					joinOn: this.oldData.joinOn,
					isActive: this.oldData.isActive,
					positionId: this.oldData.position
						? this.oldData.position.structureId
						: null,
					...uOldDocs,
					...uOldHistory,
				};

				this.$apollo
					.mutate({
						mutation: UPDATE_EMPLOYEE,
						variables: {
							input: {
								userId: parseInt(this.id),
								oldData: oldData,
								newData: input,
							},
						},
					})
					.then((response) => {
						if (response.data.updateEmployee.isSuccessful) {
							this.$apollo.queries.employee.refetch();
							this.$toast.success(`Data berhasil tersimpan`);

							setTimeout(() => {
								this.$router.push({ name: "Master Employee" });
							}, 1000);
						} else {
							var errMsg = response.data.updateEmployee.message;
							if (errMsg == 'Error: "email was registered"') {
								return this.$toast.error("Email Sudah Terdaftar");
							} else if (
								errMsg == 'Error: "employee identifier was registered"'
							) {
								return this.$toast.error("Nomor Induk Pegawai Sudah Terdaftar");
							} else {
								return this.$toast.warning(
									response.data.updateEmployee.message
								);
							}
						}
					});
			} else {
				this.$apollo
					.mutate({
						mutation: CREATE_EMPLOYEE,
						variables: {
							input: input,
						},
					})
					.then((response) => {
						if (response.data.createEmployee.isSuccessful) {
							this.$toast.success(`Data berhasil tersimpan`);

							setTimeout(() => {
								this.$router.push({ name: "Master Employee" });
							}, 1000);
						} else {
							var errMsg = response.data.createEmployee.message;
							console.log(errMsg);
							if (errMsg == 'Error: "email was registered"') {
								return this.$toast.error("Email Sudah Terdaftar");
							} else if (
								errMsg == 'Error: "employee identifier was registered"'
							) {
								return this.$toast.error("Nomor Induk Pegawai Sudah Terdaftar");
							} else {
								return this.$toast.warning(
									response.data.createEmployee.message
								);
							}
						}
					});
			}
		},

		onDocsClick(data, i) {
			data.type = "form";
			this.form.userDocs[i].type = "form";
		},

		onHistoryClick(data, i) {
			data.type = "form";
			this.form.userWorkHistory[i].type = "form";
		},

		getIdentityStatus(data) {
			if (data == "" || data == null) return null;
			var now = moment(new Date());
			var date = moment(data);
			var diff = now.diff(date, "days") * -1;

			if (diff >= 30) {
				return "Berlaku";
			} else if (diff < 30 && diff >= 0) {
				return "Akan Kedaluwarsa";
			} else if (diff <= 0) {
				return "Kedaluwarsa";
			}
		},
		onFileChange(e) {
			const file = e.target.files[0];
			var photoExt = file["type"].replace("image/", "");
			var acceptedFile = ["jpeg", "jpg", "png"];
			if (!acceptedFile.includes(photoExt)) {
				this.isFileError = true;
				return;
			}
			var size = file["size"];
			if (size >= 2048000) {
				this.isFileError = true;
				return;
			}
			this.imagePreview = URL.createObjectURL(file);
			const reader = new FileReader();
			reader.onloadend = () => {
				this.form.photo = reader.result.split(",")[1];
			};

			this.isFileError = false;
			this.form.photo = reader.readAsDataURL(file);
			this.form.photoExt = file["type"].replace("image/", "");
		},

		changeStatus(checked) {
			if (checked) {
				this.isActiveOpen = false;
			} else {
				this.isActiveOpen = true;
			}
		},

		disabledRange: function (date) {
			return date >= new Date();
		},

		changeJoinDateWorkHistory(index) {
			var self = this;
			this.form.userWorkHistory[index].disabledLeftDate = function (date) {
				if (!self.form.userWorkHistory[index].joinedOn) return null;

				var joinedOn = new Date(self.form.userWorkHistory[index].joinedOn);
				return date < joinedOn.setDate(joinedOn.getDate() - 1);
			};
		},

		isNumber(event) {
			event = (event) ? event : window.event;
			var charCode = (event.which) ? event.which : event.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				event.preventDefault();
			} else {
				return true;
			}
		}
	},
};
</script>
  
<template>
	<Layout>
		<div class="mc-list-header">
			<PageHeader :title="title" :items="items" class="mc-page-three" />

			<div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
				<div class="float-end">
					<b-button variant="outline-primary" class="mx-2" v-if="form.isDriver" @click="
						$router.push({
							name: 'Riwayat Perjalanan Pengemudi',
							params: { id: $route.params.id },
						})
					">
						{{ $t('master.form.driver.fleetHis.text') }}
					</b-button>
					<b-button @click="toCancel" variant="outline-primary" class="mx-2">
						<i class="mc-fa icon-fill_close"></i> {{ $t("global.cancel") }}
					</b-button>

					<b-button variant="primary" type="button" @click="toSave" :disabled="isFileError">
						<i class="mc-fa icon-outline_save"></i> {{ this.$t("global.save") }}
					</b-button>
				</div>
			</div>
		</div>

		<div class="mc-form">
			<h4 class="card-title">Biodata</h4>
			<b-card>
				<b-row>
					<b-col sm="12" md="6">
						<b-row>
							<b-col md="3">
								<div class="d-flex justify-content-center mb-2">
									<img :src="imagePreview" alt class="avatar-lg rounded-circle img-thumbnail"
										style="object-fit: cover" />
								</div>
							</b-col>
							<b-col md="9">
								<div class="mc-input-info">
									<span class="mc-input-info__btn" id="tooltip-info">
										<i class="bx bx-info-circle"></i>
									</span>
									<b-tooltip target="tooltip-info" triggers="click" placement="leftbottom">
										<ul>
											<li>Format (.jpg / .png)</li>
											<li>Ukuran maks. 2MB dengan resolusi (200x200) px</li>
										</ul>
									</b-tooltip>
									<b-form-group id="fleet_brand_type_label" :label="$t('master.form.driver.detailInfo.profilePhoto.text')"
										label-for="fleet_brand_type">
										<input class="form-control" @change="onFileChange" type="file" id="formFile"
											accept="image/*" :class="{ 'is-invalid': isFileError }" />
										<small class="text-danger" v-if="isFileError">{{ $t('master.form.driver.detailInfo.profilePhoto.alert') }}.</small>
									</b-form-group>
								</div>
							</b-col>
						</b-row>
					</b-col>
					<b-col sm="12" md="3">
						<b-form-group id="fleet_brand_type_label" :label="$t('master.form.driver.detailInfo.name')" label-for="fleet_brand_type"
							label-class="required">
							<b-form-input id="fullname" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.detailInfo.name')}`" v-model="form.fullname" trim :class="{
								'is-invalid': $v.form.fullname.$error,
							}"></b-form-input>
							<div v-if="$v.form.fullname.$error" class="invalid-feedback">
								<span v-if="!$v.form.fullname.required">
									Nama Lengkap Wajib Terisi
								</span>
							</div>
						</b-form-group>
					</b-col>
					<b-col sm="12" md="3">
						<b-form-group id="fleet_brand_type_label" label="Nomor Induk Pegawai"
							label-for="fleet_brand_type" label-class="required">
							<b-form-input id="employeeIdentifier" :placeholder="`${$t('global.form.enter')} ${$t('Nomor Induk Pegawai')}`"
								v-model="form.employeeIdentifier" :class="{
									'is-invalid': $v.form.employeeIdentifier.$error,
								}" trim></b-form-input>
							<div v-if="$v.form.employeeIdentifier.$error" class="invalid-feedback">
								<span v-if="!$v.form.employeeIdentifier.required">
									Nomor Induk Pegawai Wajib Terisi
								</span>
							</div>
						</b-form-group>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="thermo_type_label" :label="$t('master.form.driver.detailInfo.gender.text')" label-for="thermo_type"
								label-class="required">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="gender" id="inlineRadio1"
										v-model="form.gender" value="M" />
									<label class="form-check-label" for="inlineRadio1">{{ $t('master.form.driver.detailInfo.gender.male') }}</label>
								</div>
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="gender" v-model="form.gender"
										id="inlineRadio2" value="F" />
									<label class="form-check-label" for="inlineRadio2">{{ $t('master.form.driver.detailInfo.gender.female') }}</label>
								</div>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="box_type_label" label="Email" label-for="box_type" label-class="required">
								<b-form-input id="email" placeholder="Email" v-model="form.email" trim :class="{
									'is-invalid': $v.form.email.$error,
								}"></b-form-input>
								<div v-if="$v.form.email.$error" class="invalid-feedback">
									<span v-if="!$v.form.email.required">
										Email Wajib Terisi
									</span>
									<span v-if="!$v.form.email.email">
										Format Email Tidak Sesuai
									</span>
								</div>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="tonase_label" :label="$t('master.form.driver.detailInfo.placeBirth')" label-for="tonase">
								<b-form-input id="tonase" v-model="form.birthplace" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.detailInfo.placeBirth')}`">
								</b-form-input>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="volume_cbm_label" :label="$t('master.form.driver.detailInfo.dateBirth')" label-for="volume_cbm">
								<date-picker v-model="form.birthdate" format="DD MMM YYYY" value-type="YYYY-MM-DD"
								:placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.detailInfo.dateBirth')}`" :first-day-of-week="1" :disabled-date="disabledRange"
									lang="en" confirm></date-picker>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="chassis_number_label" :label="$t('master.form.driver.additional.marial')"
								label-for="chassis_number">
								<multiselect v-model="form.maritalStatus" :placeholder="`${$t('global.form.select')} ${$t('master.form.driver.additional.marial')}`"
									:options="maritalStatuses" label="label" trackBy="key"></multiselect>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="engine_number_label" :label="$t('master.form.driver.detailInfo.phone')" label-for="engine_number">
								<b-form-input id="engine_number" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.detailInfo.phone')}`" @keypress="isNumber($event)" v-model="form.phoneNo"
									:class="{
										'is-invalid': $v.form.phoneNo.$error,
									}" trim type="number" class="masking-number"></b-form-input>
								<div v-if="$v.form.phoneNo.$error" class="invalid-feedback">
									<span v-if="!$v.form.phoneNo.numeric">
										Nomor Telepon harus berupa angka.
									</span>
								</div>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="fleet_age_label" :label="$t('master.form.address.address')" label-for="fleet_age">
								<b-form-input id="fleet_age" v-model="form.address" :placeholder="`${$t('global.form.enter')} ${$t('master.form.address.address')}`"></b-form-input>
							</b-form-group>
						</div>
					</b-col>
				</b-row>
			</b-card>

			<h4 class="card-title">Pekerjaan</h4>
			<b-card>
				<b-row>
					<b-col sm="12" md="3">
						<b-form-group id="first_driver_label" :label="$t('master.list.driver.position')" label-for="first_driver"
							label-class="required">
							<multiselect v-model="form.position" :placeholder="`${$t('global.form.select')} ${$t('master.list.driver.position')}`" :options="position"
								track-by="name" label="name" :class="{
									'is-invalid': $v.form.position.$error,
								}" @input="positionChanged"></multiselect>
							<div v-if="$v.form.position.$error" class="invalid-feedback">
								<span v-if="!$v.form.position.required">
									Posisi Wajib Terisi
								</span>
							</div>
						</b-form-group>
					</b-col>
					<b-col sm="12" md="3">
						<b-form-group id="second_label" :label="$t('master.list.user.department')" label-for="second">
							<multiselect v-model="form.department" :placeholder="$t('master.list.user.department')" :options="department"
								track-by="name" label="name" :disabled="true"></multiselect>
						</b-form-group>
					</b-col>
					<b-col sm="12" md="3">
						<b-form-group id="second_label" :label="$t('master.list.driver.workingUnit')" label-for="second">
							<multiselect v-model="form.unit" :placeholder="`${$t('global.form.select')} ${$t('master.list.driver.workingUnit')}`" :options="unit" track-by="name"
								label="name" :disabled="true"></multiselect>
						</b-form-group>
					</b-col>
					<b-col sm="12" md="3">
						<div class="mb-3">
							<b-form-group id="thermo_type_label" :label="$t('master.list.driver.status')" label-for="thermo_type">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="isActive" id="isActive"
										v-model="form.isActive" @change="changeStatus(true)" :value="true" :disabled="cannotDelete(parseInt(id))" />
									<label class="form-check-label" for="isActive">{{ $t('master.form.user.status.active') }}</label>
								</div>
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" name="isActive" id="isActive1"
										v-model="form.isActive" @change="changeStatus(false)" :value="false" :disabled="cannotDelete(parseInt(id))" />
									<label class="form-check-label" for="isActive1">{{ $t('master.form.user.status.inactive') }}</label>
								</div>
							</b-form-group>
						</div>
					</b-col>
					<b-col sm="12">
						<div class="mt-3">
							<div class="form-check-right form-switch">
								<input class="form-check-input ms-2" type="checkbox" id="SwitchCheckSizemd"
									v-b-toggle.info-work />
								<label class="" for="SwitchCheckSizemd">
									{{ $t('master.form.driver.detailInfo.text') }}
								</label>
							</div>
						</div>
					</b-col>
					<b-collapse id="inactive-employee" accordion="inactive-accordion" role="tabpanel" class="mt-3"
						v-model="isActiveOpen">
						<b-row>
							<b-col sm="12" md="6">
								<div class="mb-3">
									<b-form-group id="inactive_on" :label="$t('master.list.driver.inActiveDate')" label-for="volume_cbm"
										label-class="required">
										<date-picker v-model="form.inactiveOn" :placeholder="`${$t('global.form.enter')} ${$t('master.list.driver.inActiveDate')}`"
											:first-day-of-week="1" format="YYYY-MM-DD" value-type="YYYY-MM-DD" lang="en"
											confirm :class="{
												'is-invalid': $v.form.inactiveOn.$error,
											}"></date-picker>
									</b-form-group>
								</div>
							</b-col>
							<b-col sm="12" md="6">
								<div class="mb-3">
									<b-form-group id="chassis_number_label" label="Alasan Nonaktif"
										label-for="chassis_number" label-class="required">
										<multiselect v-model="form.inactiveCause" placeholder="Alasan Nonaktif" :class="{
											'is-invalid': $v.form.inactiveCause.$error,
										}" :options="[
	'PHK',
	'Mengundurkan Diri',
	'Keluar Tanpa Alasan',
]"></multiselect>
									</b-form-group>
								</div>
							</b-col>
						</b-row>
					</b-collapse>
				</b-row>

				<b-collapse id="info-work" accordion="my-accordion" role="tabpanel">
					<b-row>
						<b-col sm="12" md="3">
							<div class="mb-3">
								<b-form-group id="volume_cbm_label" :label="$t('master.form.driver.additional.joinedDate')" label-for="volume_cbm">
									<date-picker v-model="form.joinOn" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.additional.joinedDate')}`"
										:first-day-of-week="1" format="YYYY-MM-DD" value-type="YYYY-MM-DD" lang="en"
										confirm></date-picker>
								</b-form-group>
							</div>
						</b-col>
						<b-col sm="12" md="3">
							<div class="mb-3">
								<b-form-group id="chassis_number_label" :label="$t('master.form.driver.additional.placeOfRecruitment')"
									label-for="chassis_number">
									<multiselect v-model="form.recruitedAt" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.additional.placeOfRecruitment')}`"
										:options="employeeRecruitedAts.employeeRecruitedAts" track-by="text"
										label="text">
									</multiselect>
								</b-form-group>
							</div>
						</b-col>
						<b-col sm="12" md="3">
							<div class="mb-3">
								<b-form-group id="thermo_type_label" :label="$t('master.form.driver.detailInfo.empType')" label-for="thermo_type">
									<div class="form-check form-check-inline">
										<input class="form-check-input" type="radio" name="isEmployee" id="isEmployee"
											v-model="form.isEmployee" :value="true" />
										<label class="form-check-label" for="isEmployee">Internal</label>
									</div>
									<div class="form-check form-check-inline">
										<input class="form-check-input" type="radio" name="isEmployee" id="isEmployee1"
											v-model="form.isEmployee" :value="false" />
										<label class="form-check-label" for="isEmployee1">External</label>
									</div>
								</b-form-group>
							</div>
						</b-col>
					</b-row>
				</b-collapse>
			</b-card>

			<div class="clearfix mb-3">
				<div class="float-start">
					<h4 class="card-title">{{ $t('master.form.driver.identity.text') }}</h4>
				</div>

				<div class="float-end">
					<b-button v-if="selected.userDocs.length" @click="toDelete('userDocs')" variant="outline-danger"
						class="mx-2">
						<i class="mc-fa icon-outline_trash"></i> {{ $t("global.delete") }}
					</b-button>
					<b-button variant="primary" @click="
						add('userDocs', {
							type: 'form',
							validUntil: '',
						})
					">
						<i class="mc-fa icon-outline_plus"></i> {{ $t("global.addField") }}
					</b-button>
				</div>
			</div>

			<b-card>
				<div class="table-responsive my-3 border border-1">
					<b-table small show-empty :empty-text="$t('global.emptyTable')"
						:empty-filtered-text="$t('global.emptyFilteredTable')" :fields="dataIdentity"
						:items="form.userDocs" @row-clicked="onDocsClick" responsive="sm" class="datatables mc-table-fleetdoc">
						<template #head(check)>
							<div class="form-check">
								<b-form-checkbox @change="toggleAll($event, 'userDocs')" v-model="allSelected.userDocs"
									:indeterminate="indeterminate.userDocs" :value="true" :unchecked-value="false">
								</b-form-checkbox>
							</div>
						</template>

						<template #cell(check)="data">
							<div class="form-check">
								<b-form-checkbox @change="checkTable($event, data, 'userDocs')"
									v-model="selectedModel.userDocs[data.index]" :value="true" :unchecked-value="false">
								</b-form-checkbox>
							</div>
						</template>

						<template #cell(columnDocument)="data">
							<div :class="{
								invalid: $v.form.userDocs.$each[data.index].docType.$error,
							}" v-if="data.item.type == 'form'">
								<multiselect class="style-chooser" v-model="form.userDocs[data.index].docType"
								:placeholder="`${$t('global.form.select')} ${$t('master.form.driver.identity.document')}`" :options="docTypeUnSelected" openDirection="top">
								</multiselect>
							</div>
							<span v-else>
								{{ data.item.docType }}
							</span>
						</template>

						<template #cell(columnNomor)="data">
							<b-form-input v-if="data.item.type == 'form'" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.identity.documentNumber')}`"
								v-model="form.userDocs[data.index].docNumber" trim></b-form-input>
							<span v-else>
								{{ data.item.docNumber }}
							</span>
						</template>

						<template #cell(columnExpired)="data">
							<date-picker v-if="data.item.type == 'form'" v-model="form.userDocs[data.index].validUntil"
								format="DD MMM YYYY" value-type="YYYY-MM-DD" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.identity.document')} ${$t('master.form.driver.identity.expired')}`"
								:first-day-of-week="1" lang="en"></date-picker>
							<span v-else>
								{{ data.item.validUntil ? momentDateShortMonth(data.item.validUntil) : '' }}
							</span>
						</template>

						<template #cell(columnStatus)="data">
							<div>
								<span v-if="getIdentityStatus(data.item.validUntil) == 'Kedaluwarsa'"
									class="mc-status mc-status--red">{{ $t('master.form.driver.identity.status.expired') }}</span>
								<span v-else-if="
									getIdentityStatus(data.item.validUntil) == 'Akan Kedaluwarsa'
								" class="mc-status mc-status--yellow">{{ $t('master.form.driver.identity.status.nearExpired') }}</span>
								<span v-else-if="getIdentityStatus(data.item.validUntil) == 'Berlaku'"
									class="mc-status mc-status--green">{{ $t('master.form.driver.identity.status.active') }}</span>
							</div>
						</template>
					</b-table>
				</div>
			</b-card>

			<div class="clearfix mb-3">
				<div class="float-start">
					<h4 class="card-title">{{ $t('master.form.driver.jobExp.text') }}</h4>
				</div>

				<div class="float-end">
					<b-button v-if="selected.userWorkHistory.length" @click="toDelete('userWorkHistory')"
						variant="outline-danger" class="mx-2">
						<i class="bx bx-trash-alt"></i> {{ $t("global.delete") }}
					</b-button>
					<b-button variant="primary" @click="
						add('userWorkHistory', {
							type: 'form',
						})
					">
						<i class="mc-fa icon-outline_plus"></i> {{ $t("global.addField") }}
					</b-button>
				</div>
			</div>

			<b-card>
				<div class="table-responsive my-3 border border-1">
					<b-table small show-empty :empty-text="$t('global.emptyTable')"
						:empty-filtered-text="$t('global.emptyFilteredTable')" :fields="dataExperience"
						:items="form.userWorkHistory" @row-clicked="onHistoryClick" responsive="sm" class="datatables">
						<template #head(check)>
							<div class="form-check">
								<b-form-checkbox @change="toggleAll($event, 'userWorkHistory')"
									v-model="allSelected.userWorkHistory" :indeterminate="indeterminate.userWorkHistory"
									:value="true" :unchecked-value="false"></b-form-checkbox>
							</div>
						</template>

						<template #cell(check)="data">
							<div class="form-check">
								<b-form-checkbox @change="checkTable($event, data, 'userWorkHistory')"
									v-model="selectedModel.userWorkHistory[data.index]" :value="true"
									:unchecked-value="false">
								</b-form-checkbox>
							</div>
						</template>

						<template #cell(columnCompany)="data">
							<b-form-input v-if="data.item.type == 'form'"
								v-model="form.userWorkHistory[data.index].companyName" trim :class="{
									'is-invalid':
										$v.form.userWorkHistory.$each[data.index].companyName
											.$error,
								}" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.jobExp.company')}`"></b-form-input>
							<span v-else>
								{{ data.item.companyName }}
							</span>
						</template>

						<template #cell(columnPosition)="data">
							<b-form-input v-if="data.item.type == 'form'" :placeholder="`${$t('global.form.enter')} ${$t('master.list.driver.position')}`"
								v-model="form.userWorkHistory[data.index].position" trim :class="{
									'is-invalid':
										$v.form.userWorkHistory.$each[data.index].position.$error,
								}"></b-form-input>
							<span v-else>
								{{ data.item.position }}
							</span>
						</template>

						<template #cell(columnEntryDate)="data">
							<date-picker v-if="data.item.type == 'form'"
								v-model="form.userWorkHistory[data.index].joinedOn" :class="{
									'is-invalid':
										$v.form.userWorkHistory.$each[data.index].joinedOn.$error,
								}" format="DD MMM YYYY" value-type="YYYY-MM-DD" :placeholder="`${$t('global.form.enter')} ${$t('master.form.driver.additional.joinedDate')}`" :first-day-of-week="1"
								lang="en" @input="changeJoinDateWorkHistory(data.index)">
							</date-picker>
							<span v-else>
								{{ momentDateShortMonth(data.item.joinedOn) }}
							</span>
						</template>

						<template #cell(columnExitDate)="data">
							<date-picker v-if="data.item.type == 'form'"
								v-model="form.userWorkHistory[data.index].leftOn" :class="{
									'is-invalid':
										$v.form.userWorkHistory.$each[data.index].leftOn.$error,
								}" format="DD MMM YYYY" value-type="YYYY-MM-DD" :placeholder="`${$t('global.form.enter')} ${$t('master.list.driver.inActiveDate')}`" :first-day-of-week="1"
								lang="en"
								:disabled="form.userWorkHistory[data.index].joinedOn == null || form.userWorkHistory[data.index].joinedOn === undefined"
								:disabled-date="form.userWorkHistory[data.index].disabledLeftDate">
							</date-picker>
							<span v-else>
								{{ momentDateShortMonth(data.item.leftOn) }}
							</span>
						</template>
					</b-table>
				</div>
			</b-card>
		</div>
	</Layout>
</template>
  